import { memo } from 'react';
import { HeadphonesOn, HeadphonesOff } from '@rsos/assets/icons';
import { Box } from '@rsos/base-components';

const CallTakerModeIcon = memo(({ callTakerModeSettings }) => (
  <Box
    data-name={`call-taker-mode-${
      callTakerModeSettings?.is_enabled ? 'on' : 'off'
    }`}
  >
    {callTakerModeSettings?.is_enabled ? (
      <HeadphonesOn
        color="success"
        viewboxWidth={18}
        viewboxHeight={16}
        width={18}
        height={16}
      />
    ) : (
      <HeadphonesOff
        color="secondaryLink"
        viewboxWidth={18}
        viewboxHeight={16}
        width={18}
        height={16}
      />
    )}
  </Box>
));

export default CallTakerModeIcon;
